// src/pages/AllArticle.js
import React from 'react';
import SEO from '../components/SEO';
// ❌ Removed BlogHeader import
import BlogLayout from '../components/BlogLayout';

const AllArticle = () => {
  return (
    <>
      <SEO
        title="All Articles | Oolook Logbook"
        description="Browse the complete archive of articles from Oolook on AI, social media marketing, content creation, and productivity."
      />
      {/* ❌ Removed BlogHeader component */}
      <main className="bg-dark-bg pt-24 sm:pt-32"> {/* ✅ Added top padding */}
        <BlogLayout 
          title="All Articles"
        />
      </main>
    </>
  );
};

export default AllArticle;